const types = {
    SET_HISTORY_LIST: '[REPORT BONUSES] SET HISTORY LIST',
}

export {
    types,
}